export default __webpack_public_path__ + "img/redo.44eea1a1.svg";